import type { Components, Theme } from '@mui/material/styles';

import { borders } from '@/theme/constants';
import typography from '@/theme/typography';

const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: ({ theme: { spacing, palette } }: { theme: Theme }) => ({
      '& .MuiToggleButton-root': {
        borderRadius: spacing(0.5),
        padding: spacing(0.5),
        paddingLeft: spacing(2),
        paddingRight: spacing(2),
        margin: spacing(0.5),
        color: palette.grey[800],
        border: borders.getSolid(palette.grey[400]!, borders._1px),
        textTransform: 'none',
        backgroundColor: palette.background.default,
        ...typography.body3,
        lineHeight: 1.5,
        fontWeight: typography.fontWeightRegular
      },
      '& .MuiToggleButton-root:hover': {
        background: palette.primary[200],
        borderColor: palette.primary[200]
      },
      '& .MuiToggleButton-root.Mui-selected:hover': {
        background: palette.primary[200]
      },
      '& .MuiToggleButton-root.Mui-selected': {
        color: palette.primary.main,
        marginLeft: spacing(0.5),
        borderLeft: borders.getSolid(palette.primary.main, borders._1px),
        borderColor: palette.primary.main,
        backgroundColor: palette.background.default
      }
    })
  },
  variants: [
    {
      props: { color: 'primary' },
      style: ({ theme: { spacing, palette } }) => ({
        backgroundColor: palette.primary[100],

        '& .MuiButtonBase-root': {
          paddingY: spacing(0.625),
          border: 'none !important',
          ...typography.body3
        },
        '& .MuiButtonBase-root.Mui-selected': {
          fontWeight: typography.fontWeightMedium
        },
        '& .MuiButtonBase-root:not(.Mui-selected)': {
          color: palette.primary[300],
          backgroundColor: 'transparent'
        }
      })
    }
  ]
};

export default MuiToggleButtonGroup;
